import { render, staticRenderFns } from "./busseess.vue?vue&type=template&id=563fd62f&scoped=true"
import script from "./busseess.vue?vue&type=script&lang=js"
export * from "./busseess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563fd62f",
  null
  
)

export default component.exports